<template>
  <Head title="Reset password" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <Logo class="block mx-auto w-full max-w-xs fill-white" height="140" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <input type="hidden" name="token" value="{{ $token }}">
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">Reset Password</h1>
          <div class="mt-6 mb-4 mx-auto w-24 border-b-2" />

          <div v-if="$page.props.flash.error" class="flex items-center justify-between mb-8 max-w-3xl bg-red-500 rounded">
            <div class="flex items-center">
              <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
              <div v-if="$page.props.flash.error" class="py-4 text-white text-sm font-medium">{{ $page.props.flash.error }}</div>

            </div>
            <a class="hover:no-underline text-white text-sm font-medium mr-4" tabindex="-1" href="/forgot-password">Resend</a>
          </div>

          <span class="text-center text-lg">Enter your new password.</span>
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="mt-6" label="Confirm password" type="password" />
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <div class="mt-auto mb-auto">
            <a class="hover:underline" tabindex="-1" href="/login">Back</a>
          </div>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Save Password</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
  },
  props: {
    token: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        password: '',
        password_confirmation: '',
        token: this.token,
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/reset-password')
    },
  },
}
</script>
